<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!menu">
    <tt-card>
        <tt-input ttLabel="stockplace_name" [ttModel]="menu.stockplace_name" ttReadonly></tt-input>
        <tt-input ttLabel="prod_id" [ttModel]="menu.prod_id" ttReadonly></tt-input>
        <tt-input ttLabel="prod_name" [ttModel]="menu.prod_name" ttReadonly></tt-input>
        <tt-checkbox ttLabel="include_not_in_stock" [(ttModel)]="menu.include_not_in_stock" (ttModelChange)="onChanged($event, 'include_not_in_stock')"></tt-checkbox>
    </tt-card>

    <tt-list [ttData]="itemsListStockVariantsOfProdIds"></tt-list>
</tt-page>
